import React from 'react';
import Logo from './Logo';

const LogoTest = () => {
  return (
    <div className="p-8 space-y-4">
      <h2 className="text-2xl font-bold">Logo Test</h2>
      
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold mb-2">Responsive Logo (Large)</h3>
          <Logo size="large" responsive={true} />
        </div>
        
        <div>
          <h3 className="text-lg font-semibold mb-2">Responsive Logo (Medium)</h3>
          <Logo size="medium" responsive={true} />
        </div>
        
        <div>
          <h3 className="text-lg font-semibold mb-2">Responsive Logo (Small)</h3>
          <Logo size="small" responsive={true} />
        </div>
        
        <div>
          <h3 className="text-lg font-semibold mb-2">Direct File Test</h3>
          <img 
            src="/logos/logo-full-with-icon.svg" 
            alt="Full Logo Test" 
            className="h-12 w-auto"
            onError={(e) => console.error('Full logo failed to load')}
            onLoad={() => console.log('Full logo loaded successfully')}
          />
          <br />
          <img 
            src="/logos/logo-compact.svg" 
            alt="Compact Logo Test" 
            className="h-12 w-auto"
            onError={(e) => console.error('Compact logo failed to load')}
            onLoad={() => console.log('Compact logo loaded successfully')}
          />
        </div>
      </div>
    </div>
  );
};

export default LogoTest; 